function link_home(u){
  if(u != ''){
        window.location.href = 'https://www.gamboafashion.com'+u;
  } 
}

function InfoHat(params='') {
  const elem = document.getElementById('ProductPopup-dfa4a199-4913-400e-9390-105dfe606c48');
  elem.click();
}

function showFold(params=''){
  const elem = document.getElementById('ProductPopup-84618ee1-a1bf-439f-86c3-a78d937cf65d');
  elem.click();
}

function raisePopupWindow(params=''){
  const elem = document.getElementById('ProductPopup-e574306a-512c-48b4-8b2d-e0dd3f7fe1e4');
  elem.click();
}